<div>
  <section>
    <div class="primary-image"></div>
  </section>
  <section>
    <div class="text-description">
      <h1>Débora e João Pedro</h1>
      <h2>Estão se casando</h2>
      <p>
        E a melhor forma de compartilhar esses momentos com vocês é unindo
        sonhos. Aqui vamos contar a vocês, queridos amigos e familiares os
        momentos mais marcantes da nossa história de amor.
      </p>
      <p>
        A contagem regressiva começa, o frio na barriga e toda a ansiedade do
        dia mais esperado de nossas vidas nos enche de alegria, principalmente
        em tê-lo ao nosso lado. Vamos juntos neste grande sonho, o dia em que
        uniremos nossas almas, o dia do nosso casamento.
      </p>
    </div>
  </section>
  <section>
    <div class="grid-container">
      <div class="photo1"></div>
      <div class="photo2"></div>
      <div class="photo3"></div>
      <div class="photo4"></div>
    </div>
  </section>
</div>
